var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nav_item_icon",
    fill: "#A3AED0",
    id: "XMLID_152_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deployment"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,24c-0.2,0-0.4,0-0.5-0.1c-0.6-0.2-1.1-0.7-1.3-1.4L10,19.2c-0.1-0.5-0.3-0.9-0.6-1.2l-3.3-3.3 c-0.3-0.3-0.7-0.5-1.2-0.6l-3.4-0.7c-0.7-0.1-1.2-0.6-1.4-1.3c-0.2-0.6,0-1.3,0.5-1.8l2.6-2.6C4,6.9,5.1,6.3,6.3,6.3h3.1 c0.8-0.9,1.6-1.8,2.4-2.6C17.5-2,22.7,0.5,22.9,0.6l0.3,0.2l0.2,0.3c0.1,0.2,2.5,5.5-3.1,11.1c-0.9,0.9-1.8,1.7-2.6,2.4v3.1 c0,1.2-0.5,2.2-1.3,3.1l-2.6,2.6C13.4,23.8,12.9,24,12.4,24z M2.2,11.5l3.1,0.6c0.8,0.2,1.6,0.6,2.2,1.2l3.3,3.3 c0.6,0.6,1,1.4,1.2,2.2l0.6,3.1l2.4-2.4c0.4-0.4,0.7-1,0.7-1.6v-4l0.4-0.3c1-0.8,1.9-1.7,2.9-2.6c3.9-3.9,3.2-7.4,2.9-8.5 c-1.1-0.4-4.6-1-8.5,2.9c-0.9,0.9-1.8,1.9-2.6,2.9l-0.3,0.4h-4c-0.6,0-1.2,0.2-1.6,0.7L2.2,11.5z M2.1,24L2.1,24 c-0.8,0-1.3-0.1-1.6-0.4c-0.2-0.2-0.7-0.7-0.3-3.1c0.2-1.1,0.5-2.6,1.3-3.4c1.5-1.5,4-1.5,5.4,0c1.5,1.5,1.5,3.9,0,5.4 C5.8,23.7,3.3,24,2.1,24z M4.3,18c-0.5,0-1,0.2-1.3,0.5C2.4,19.1,2.1,21,2.1,22c1,0,2.9-0.3,3.5-0.8c0.7-0.7,0.7-1.9,0-2.6 C5.2,18.2,4.7,18,4.3,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,10c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S18.7,10,17,10z M17,6c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S17.6,6,17,6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.4ac6b42ce018e974f9bb4da6aa50c9a2.svg";
export { ForwardRef as ReactComponent };